import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aaf6b732"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "ceva" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ld_input = _resolveComponent("ld-input")!
  const _component_setting_row = _resolveComponent("setting-row")!

  return (_openBlock(), _createBlock(_component_setting_row, {
    title: _ctx.$props.title,
    description: _ctx.$props.description,
    loading: _ctx.$props.loading,
    disabled: _ctx.btnDisabled,
    onSave: _ctx.saveSetting
  }, {
    default: _withCtx(() => [
      _createElementVNode("label", null, _toDisplayString(_ctx.$props.measurementIdLabel), 1),
      _createVNode(_component_ld_input, {
        name: _ctx.$props.measurementIdSettingKey,
        type: "text",
        placeholder: _ctx.$props.measurementIdPlaceholder,
        medium: "",
        "sr-only": "",
        class: "my-3",
        value: _ctx.$props.measurementId,
        disabled: _ctx.disabled
      }, null, 8, ["name", "placeholder", "value", "disabled"]),
      _hoisted_1,
      _createElementVNode("label", null, _toDisplayString(_ctx.$props.apiSecretLabel), 1),
      _createVNode(_component_ld_input, {
        name: _ctx.$props.apiSecretSettingKey,
        type: "text",
        placeholder: _ctx.$props.apiSecretPlaceholder,
        medium: "",
        "sr-only": "",
        class: "my-3",
        value: _ctx.$props.apiSecret,
        disabled: _ctx.disabled
      }, null, 8, ["name", "placeholder", "value", "disabled"])
    ]),
    _: 1
  }, 8, ["title", "description", "loading", "disabled", "onSave"]))
}